<template lang="pug">
  .montenegro
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/montenegro-min.png"
      )
      span {{ gettext('Черногория') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content.one-grid
      div
        p {{ gettext('Черногорские люди – южные славяне, которые живут на маленькой территории, богатой на красивые пейзажи – гор, каньонов, рек и побережья Адриатического моря. Это наименее густонаселенная страна в южной Европе, в которой проживает всего 630 000 человек. Черногорцы, как и другие горные народности – высоко ценят честь и достоинство, семью и традиции. Они сильны как физически, так и духовно, сдержанны и учтивы. Черногория всегда была тесно связанной с Сербией, но имела свою государственность. На сегодня Черногория является официальным кандидатом на членство Евро союза, но до присвоения статуса полноправного члена ЕС черногорцам все еще требуется оформлять разрешения на работу и пребывание.')}}
        p {{ gettext('Основной отраслью экономики Черногории, приносящей прибыль государству, является туризм. Средняя заработная плата в стране составляет 470 евро, но далеко не все жители могут реализовать рабочий потенциал в своей родной стране.') }}
        p {{ gettext('Черногорцы едут зарабатывать деньги в соседние страны – Сербию, Албанию, Хорватию, Словению. Также в Италию, Аргентину и Канаду. Черногорцы нацелены на работу в Северной Европе, поскольку заработная плата там сравнительно выше стран-соседок, но пока большого потока людей не наблюдается.') }}
        p {{ gettext('Работники с Черногории хорошо управляются с работой в сельском хозяйстве, также многие из них имеют успех в сфере обслуживания, производстве, в отрасли транспорта и технологий, строительства и других.') }}
        p {{ gettext('Из иностранных языков в Черногории распространены английский и итальянский, английский изучают в школах и высших учебных заведениях.') }}
        p {{ gettext('Черногорцы как работники очень ответственны, и не хотят запятнать свою честь недобросовестной работой, всегда стараются довести дело до конца и показать лучший результат. Многие работодатели характеризируют черногорских работник как надежных, не боящихся работы и ответственности.') }}
        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/montenegro-min.png'})
  },
  name: 'Montenegro',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Montenegro | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/montenegro/index.vue